import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  // tslint:disable
  public questions: [string, string][] = [
    [
      "How can I trust a bounty reward to be paid?",
      `The website uses a trust/reputation system. Users gain stars for every bounty paid out, so users with more stars are more likely to be trustworthy.

New users start out with 0 stars, so be cautious when taking on bounties by such users as there is no guarantee they will pay you.
You can use the 'trusted-only' filter to only show bounties made by people who have paid out bounty rewards before.

In addition to this, every user who creates a bounty must have verified their osu profile, meaning that you can know exactly who they are, and they will not easily be able to just make another account when banned.

Bounty creators who fail to pay their bounties will be banned from the site. You can report non-paid bounties via our discord server.

In the case of bounties with a reward pool, the reward money is pre-paid and held by osustuff.org, so the chosen winner will be guaranteed to receive the reward.`
    ],
    [
      "Can't cheaters claim bounties with cheated scores?",
      `Cheating is unfortunately a problem in osu, due to the lack of effective anti cheat systems. This fact makes this website susceptible to cheaters as well. If you are thinking of creating a bounty, please keep this in mind and make your own decision.

We have certain measures to prevent known cheaters from keeping using the site. Firstly, to claim a bounty, users must verify their user profile so we know who they are in-game. Scores used to claim bounties should be submitted online. This means that offline plays should not count, and they at least have to go through the osu anti cheat system.

Users who are found to be claiming lots of bounties will be investigated for their legitimacy, and if they are unable to provide reasonable evidence that they aren't cheating, they will be banned from the site.

If you are concerned about a claim to your bounty not being legit, you have the right to deny the claim or request further evidence such as a live play as a requirement.`
    ],
    [
      "How quickly should payment be made once a winner is chosen?",
      `We will allow up to 7 days for the bounty creator to send payment to the winner, unless there is a valid reason not to.

If the bounty reward isn't paid within this time frame without a valid reason (which a moderator will judge), the bounty creator
may be banned from using the service again`
    ],
    [
      "How long does it take for bounty claims to be reviewed / accepted?",
      `It is the bounty creator's job to accept/deny claims unless a moderator does it for them.

Claims should normally be reviewed within 3 days however in certain circumstances it may take longer (e.g.) if the bounty creator is on holiday/vacation.`
    ],
    [
      "Is there a system to stop people making bounties for impossible plays?",
      `We try to remove bounties that are humanly impossible (meaning not even the world's top player
has a realistic chance of getting them).

A bounty report system is coming soon for people to report troll bounties, however for now, I encourage users to use the discord
server or to leave a comment on the bounty page itself.`
    ],
    [
      'How are reward pools collected for bounties with a reward pool?',
      `To contribute to a reward pool, the user must pay the full amount upfront to osustuff.org. The money will then be held in osustuff.org's paypal business account until the end of the bounty, and once someone wins the bounty, they will be sent the total amount shown for the  bounty reward. If no one wins the bounty, everyone who contributed to the reward pool will be refunded automatically.`
    ],
    [
      'Why do reward pool contributions need to be paid upfront?',
      `To guarantee that the winner of the bounty will receive the full amount shown.`,
    ],
    ['Are reward pool contributions refundable?',
      `Contributions to a bounty reward pool can be withdrawn and refunded up until the point where
a winner has been chosen for the bounty. Once a winner has been chosen, it is no longer refundable.

You can view your bounty contributions on your profile (click your name on the top section of the website)`
    ],
    ['For bounties with reward pools, how is the winner chosen?',
      `For pooled reward bounties, only a website admin can choose the winner. This is different to non-pooled bounties
where the bounty creator would pick the winner. The reason only admins can pick the winner for pooled bounties
is to prevent abuse of the system (e.g. the bounty creator colluding with another user in order to get the money.)`
    ],
    [
      'Can pooled bounties be changed or deleted by the bounty owner after creation?',
      `No. Once a pooled bounty is created, the bounty is in a fixed state (i.e. goals cannot change and it cannot be deleted).
Only a website moderator can edit a pooled bounty (e.g. to correct mistakes in the listing)`,
    ],
    [
      'Why is there a 10% transaction fee on bounty pool payments?',
      `This is mainly to cover paypal fees, which vary between ~3.4% to 23% of the payment amount, depending on the amount paid. For smaller contributions (under 3$),
we actually lose a bit of money (for a $1 payment, 23 cents by paypal, which results in a 13 cent loss to us). For larger payments, we will make a small profit on the contribution, which will be used towards server costs and time spent maintaining and developing the site.

The transaction fee of 10% may be adjusted up or down in the future.`,
    ],
  ];
  // tslint:enable

  ngOnInit() { }
}
